<template>
  <div class="social">
    <a target="_blank" href="https://www.linkedin.com/in/chunhakrai-buncherdjaruwong-299a461a8/"
      ><span class="fa fa-linkedin-square"></span
    ></a>
    <a target="_blank" href="https://twitter.com/"
      ><span class="fa fa-envelope"></span
    ></a>
  </div>
</template>

<script>
export default {
  name: "profile-socials"
};
</script>

<style scoped></style>
